// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__Fo1KJ","accordion_header":"Accordion_accordion_header__RGpL5","accordion_content":"Accordion_accordion_content__Wwpnw"};